import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45general_45global from "/vercel/path0/middleware/01.general.global.js";
import _02_45team_45global from "/vercel/path0/middleware/02.team.global.js";
import _03_45league_45global from "/vercel/path0/middleware/03.league.global.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45general_45global,
  _02_45team_45global,
  _03_45league_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "game-data": () => import("/vercel/path0/middleware/game-data.js")
}